import { ContactFormController, SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { ContactPage } from '@presentation/pages';

export const ContactPageController = () => {
  const { translate } = useRouter();

  return (
    <>
      <SeoController
        title={translate('contact.seo.title')}
        description={translate('contact.seo.description')}
      />

      <ContactPage>
        <ContactFormController />
      </ContactPage>
    </>
  );
};
